var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocusdcirclemobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.97549,
    cy: 7.86758,
    r: 7.30118,
    fill: "url(#paint0_linear_2960_2525)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2960_2525",
    x1: 0.674316,
    y1: 7.86758,
    x2: 15.2767,
    y2: 7.86758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B30505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9819C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusdcirclemobile);
export default __webpack_public_path__ + "static/media/focusdcirclemobile.60fde24378b3f3c4bd923a99f1c1bc65.svg";
export { ForwardRef as ReactComponent };